export default __webpack_public_path__ + "static/media/accurityLogo.2da562be.svg";